import axios from 'axios';
import { syncUserFromToken } from '../utils/auth.js';

// Function to refresh tokens (NodeJS backend)
const refreshToken = async () => {
  try {
    console.log(process.env.REACT_APP_API_BASE);
    const API_BASE = process.env.REACT_APP_API_BASE;
    const response = await axios.post(`${API_BASE}api/v1/auth/refresh`, {
      refreshToken: localStorage.getItem('refresh-token')
    },{
      headers: {
        'Content-Type': 'application/json',
      }
    });
    const { accessToken, refreshToken: newRefreshToken } = response.data;
    if (accessToken) {
      syncUserFromToken(accessToken, newRefreshToken);
      return accessToken;
    }
    throw new Error('Invalid refresh response');
  } catch (error) {
    console.error('Token refresh failed:', error);
    localStorage.clear();
    window.location.href = '/signin';
    throw error;
  }
};

const AUTH_NO_REFRESH_PATHS = [
  '/api/v1/auth/signin',
  '/api/v1/auth/signup',
  '/api/v1/auth/refresh',
  '/api/v1/auth/resetpassword',
];

const isAuthNoRefreshRequest = (config = {}) => {
  const requestUrl = `${config.baseURL || ''}${config.url || ''}`;
  return AUTH_NO_REFRESH_PATHS.some((path) => requestUrl.includes(path));
};

// Create an Axios instance with interceptors
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access-token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error?.response?.status === 401 &&
      !originalRequest._retry &&
      !isAuthNoRefreshRequest(originalRequest)
    ) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshToken();
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Handle token refresh failure, e.g., redirect to login page
        console.error('Token refresh error:', refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
